import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {debug} from '../../../rxjs-operators';
import {BaseEffect} from './base.effect';
import {SendBackResult} from '../models/send-back-result';
import {ArrayResponse} from '../models/array-response';
import {error} from '../actions/toasts';
import {catchError, map, switchMap} from 'rxjs/operators';
import {LoadTestDataFailAction, LoadTestDataSuccessAction, testDataActionTypes} from '../actions/test-data';
import {TestDataService} from '../services/test-data.service';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class TestDataEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(
    ofType(testDataActionTypes.LOAD),
    debug('Load testData action received;'),
    switchMap(() => this.testDataService.geTestData().pipe(
      map((payload: SendBackResult<ArrayResponse<number>>) => new LoadTestDataSuccessAction(payload.data.array)),
      catchError(res => this.catchResponseError(res)))
    ))
  });

  loadFail$ = createEffect(() => { return this.actions$.pipe(
    ofType(testDataActionTypes.LOAD_FAIL),
    debug('Load testData fail action received.'),
    map((action: LoadTestDataFailAction) =>
      error(this.translation.translate('COUNTRIES_LOAD_ERROR') + '  ' + action.payload, this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions, private translation: L10nTranslationService, private testDataService: TestDataService, router: Router) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadTestDataFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadTestDataFailAction(response['error'].message);
  }
}
